import type { SpatialTerminal } from '@/types';
import type { ObjectRendererProps } from './types';
import styles from '../ObjectView.module.css';

/** Read-only scrollback view; an executing shell is out of scope for a frontend-only build. */
export const TerminalRenderer = ({ object: term }: ObjectRendererProps<SpatialTerminal>) => (
  <>
    <header className={styles.titlebar}>
      <strong>{term.name}</strong>
      <span>{term.cwd}</span>
    </header>
    <pre className={styles.terminal} aria-label={`${term.name} output`}>
      {term.scrollback.length ? term.scrollback.join('\n') : `${term.cwd} $ `}
    </pre>
  </>
);
